const translations = {
    header: {
        title: 'Formulari d\'accés a Matricula Tecnocampus',
        sub_title: 'Si aquest és el primer any que estudies al nostre centre, agrairem que dediquis uns minuts del teu temps a omplir aquesta enquesta.',
        description: 'Ens ajudarà a planificar l’acollida dels teus companys de cursos posteriors i, en general, a millorar la qualitat dels nostres serveis.'
    },
    btns_form:{
        next: 'Següent',
        previous: 'Anterior',
        submit: 'Enviar'
    },
    title: 'Formulari enquesta nous alumnes',
    sub_title: 'Omple el següent formulari',
    survey_close: {
        msg: 'Enquesta tancada!',
        sub_msg: 'Lamentem informar que l\'enquesta, Nou accés als Graus del Tecnocampus, està tancada'
    },
    tabs:{
        personal_data: {
            title: 'Dades personals',
            name: 'Nom',
            surname1: 'Primer cognom',
            surname2: 'Segon cognom',
            dni: 'NIF/NIE/Passaport',
            phone: 'Telèfon mòbil',
            gender: 'Gènere',
            email: 'Correu personal',
            birthday: 'Data naixement',
            grade: 'Grau que curses',
            provincia: 'Provincia',
            population: 'Municipi de residència',
            country: 'País',
            placeholder_country: 'Selecciona un país',
            question1: 'Si durant el curs acadèmic no vius en el teu municipi de residència, indica en quin tipus d\'allotjament vius (marca una de les opcions)',
            question2_1 :'Compaginaràs els estudis amb una feina?',
            question2_2: 'En cas afirmatiu, indica una de les següents opcions'
        },
        photo:{
            title: 'Fotografia',
            intro: 'Aquesta fotografia s\'utilitzarà per generar el vostre carnet d\'estudiant.',
            requirements_title: 'La fotografia ha de complir els següents criteris, en cas contrari no us permetrà continuar, i no es podrà generar la vostra alta correctament:',
            requirements: [
                "El tamany de la fotografia no pot superar com a <strong>màxim 4Mb</strong> de pes",
                "La imatge ha de tenir un tamany mínim de 176px d'amplada i 220px d'alçada.",
                "La foto ha de ser de tipus bust. Vol dir que la imatge no pot ser de cos sencer, ni de mig cos, com a molt de pit cap a munt, o només de cara, es <strong>molt important que es vegi la cara sencera i que sigui identificable</strong>, preferiblement amb el fons blanc."
            ],
            instructions: 'Arrossega una imatge en el requadre o fes servir el botó d\'Afegir fotografia',
            add_photo: 'Afegir fotografia',
            crop_photo: 'Retallar foto',
            remove_photo: 'Treure la foto',
            note: 'Aquesta foto és la que es farà servir per al teu carnet d\'estudiant i per al campus virtual',
            upload_photo: 'Pujar fotografia',
            make_photo: 'Fer fotografia',
            file_title: 'Foto de Carnet',
            select_webcam: 'Selecciona la càmera',
            take_snapshot: 'Capturar imatge',
            errors: {
                no_foto: "<p>No s'ha afegit cap fotografia</p>",
                mida: "<p>Recorda: </p>" +
                    "<p>Mides 175px d'amplada i 220px d'alçada màxim</p>" +
                    "<p>El pes del fitxer no ha de ser de més de 4Mb</p>",
                mida_superada: 'La mida del fitxer supera 4Mb o no cumpleix amb les mides requerides mínimes.'
            }
        },
        academic_data: {
            title: 'Dades Acadèmiques',
            description: 'Dades Acadèmiques dels últims estudis cursats',
            question1: 'Estudis cursats (indica només els últims estudis que has fet)',
            question2: 'Tipus de batxillerat cursat',
            question3: 'Centre Acadèmic (dels últims estudis)',
        },
        title_selection:{
            title: 'Selecció Titulació/Centre',
            description: 'Selecció de la Titulació i el Centre',
            question1: 'Valora del 0 (menys important) al 10 (molt important) els diferents aspectes que t\'han ajudat a decidir a optar per cursar els estudis a Tecnocampus',
            question2: 'Com ens has conegut?',
            errors: {
                missing_answers: 'Hi ha respostes sense contestar'
            }
        },
        expectations:{
            title: 'Expectatives',
            description: 'Expectatives',
            question1: 'Valora de 1 (poc important) a 5 (molt important) els següents aspectes segons la importància que creus que han de tenir per a rebre una bona formació universitària',
            errors: {
                missing_answers: 'Hi ha respostes sense contestar'
            }
        },
        comunication: {
            title: 'Comunicació',
            description: 'Comunicació',
            question1: 'Indica els canals de comunicació a través dels quals t\'agradaria rebre informació sobre els teus estudis i/o l\'actualitat de la universitat',
            errors: {
                missing_answers: 'Hi ha respostes sense contestar'
            }
        },
        transport:{
            title: 'Transport',
            description: 'Transport',
            question1: 'Marca el mitjà de transport que faràs servir per venir a estudiar al centre. Si uns dies véns amb un mitjà i altres amb un altre diferent, marca només el que serà més habitual.',
            errors: {
                missing_answers: 'Hi ha respostes sense contestar'
            }
        },
        impressions: {
            title: 'Impressions',
            description: 'Primeres Impressions',
            question1: 'Valora la qualitat de la informació disponible sobre el procés de matrìcula (documentació; que has de lliurar, quan has de venir, dia i hora, lloc, etc).',
            question2: 'Valora la qualitat de la informació acadèmica (informació dels estudis a cursar: plans docents, horaris, etc) disponible abans de la matrícula',
            question3: 'Altres comentaris que vulguis fer, adreçats a la Direcció del Centre',
            policies_accepted: 'Accepto les condicions de la <a target="_blank" href="http://www.tecnocampus.cat/ca/avis-legal">política de privacitat</a>',
            policies: '<b>Autoritzo expressament a la Fundació Tecnocampus Mataró-Maresme a tractar les meves dades personals amb la finalitat de realitzar el tractament estadístic de les enquestes als estudiants de nou accés.</b>\n' +
                '          Les dades personals facilitades seran incorporades al fitxer de dades <b>“Enquesta als estudiants de nou accés”</b>.\n' +
                '          Les dades estadístiques no s’utilitzen amb noms associats. Aquestes dades només seran cedides a tercers en aquells casos en què sigui necessari per al compliment de les obligacions legalment establertes.\n' +
                '          L\'informem que en qualsevol moment podrà exercir els seus drets d\'accés, rectificació, supressió i oposició, remetent un escrit identificat amb la referència "Protecció de Dades", en el qual s\'acompanyi una fotocòpia\n' +
                '          del document nacional d\'identitat del titular de les dades, i en el qual consti la petició en què es concreta la sol·licitud, una adreça a efectes de notificacions, data i signatura, a la següent adreça electrònica\n' +
                '          rgpd@tecnocampus.cat, o bé mitjançant una carta prefranquejada adreçada a la Secretaria General de la Fundació Tecnocampus Mataró-Maresme (Avinguda d’Ernest Lluch, 32 Edifici Universitari, 08302 Mataró).',
            errors: {
                missing_answers: 'Hi ha respostes sense contestar'
            }
        },
        end:{
            title: 'End',
            thanks: 'Gràcies per realitzar el seu registre',
            detail1: 'Li hem enviat un email a la seva adreça de correu amb la confirmació del registre de l\'enquesta,\n' +
                '        <strong>és necessari que porti el resguard amb la documentació el dia de la matricula</strong>',
            detail2: 'Si vol pot imprimir les dades de la següent taula com a Resguard o si ho prefereix pot imprimir el justificant que li hem enviat per correu',
            guard: 'Resguard del formulari de l\'enquesta de matrícules de nou accés a Tecnocampus',
            guard_title:'Dades del registre realitzat',
            print:'Imprimir resguard'
        }
    }
}

export default  translations;